import { useEffect, useRef, useState } from 'react';

export function usePromise<R = any, E = Error>(
  onFetch: () => PromiseLike<R>,
  deps: any[],
  options?: { bypass?: boolean }
) {
  const isMounted = useRef(true);
  const [response, setResponse] = useState<[null | R, null | E]>([null, null]);
  const fetch = async () => {
    try {
      const res = await onFetch();
      if (isMounted.current) {
        setResponse([res, null]);
      }
    } catch (err: any) {
      if (isMounted.current) {
        setResponse([null, err]);
      }
    }
  };
  useEffect(() => {
    if (!options?.bypass) {
      fetch();
    }
    return () => {
      isMounted.current = false;
    };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
  return response;
}
